import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { KlaHttpService } from '../services/kla.http.service';
import { VideoConfigurations } from './video.configurations';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TitleConfigurations, TitleLineConfigurations } from '../title/title.configurations';
import { CommonModule } from '@angular/common';
import { SafeResourceUrlPipe } from '../safe-resource-url/safe-resource-url';
import { VgBufferingModule } from '@videogular/ngx-videogular/buffering';
import { VgControlsModule } from '@videogular/ngx-videogular/controls';
import { VgOverlayPlayModule } from '@videogular/ngx-videogular/overlay-play';
import { VgCoreModule } from '@videogular/ngx-videogular/core';

@Component({
  selector: 'kla-video',
  templateUrl: './video.component.html',
  styleUrls: ['./video.component.scss', '../../../app.component.scss'],
  standalone: true,
  imports: [ CommonModule, SafeResourceUrlPipe, VgBufferingModule, VgControlsModule, VgOverlayPlayModule, VgCoreModule]
})
export class VideoComponent implements OnInit {

  constructor(private sanitizer: DomSanitizer) {}

  @Input()
  public config: any;

  public sources: Array<any> = [];
  public classVideo = false;

  @Input()
  public url: string;

  @Input()
  public lineConfig: TitleLineConfigurations;

  @Input()
  public titleConfig: TitleConfigurations;

  @ViewChild('videoPlayer', {static: true})
  public videoPlayer: ElementRef;

  public youTubeLink: SafeResourceUrl;

  toggleVideoClass() {
    this.classVideo = !this.classVideo;
  }

  ngOnInit() {
    if (this.config && !this.config.youtubeVideo) {
      this.sources.push({
        src: this.sanitizer.bypassSecurityTrustUrl(this.config.video.sourceUrl),
        type: 'video/' + this.getVideoType(this.config.video.sourceUrl)
      });
    } else {
      this.youTubeLink = this.config.video.sourceUrl;
    }
  }

  private getVideoType(url: string) {
    const parts = url.split('.');
    return parts[parts.length - 1];
  }

}
